import { useEffect, useRef, useState } from 'react';
export const useStickedToolbar = () => {
  const toolbar = useRef(null);
  const [sticked, setSticked] = useState(false);

  /**
   * Check if the element is sticked depending on the initial position.
   * Intersection provider doesn't work here when the toolbar has an offset (so there is no decrease in the intersection)
   */
  useEffect(() => {
    function check() {
      if (!toolbar.current) {
        return setSticked(false);
      }
      const currentTop = toolbar.current.getBoundingClientRect().top ?? 0;
      const initialTop = Number.parseInt(window.getComputedStyle(toolbar.current).top, 10);
      setSticked(currentTop <= initialTop);
    }
    window.addEventListener('scroll', check, {
      passive: true
    });
    return () => {
      window.removeEventListener('scroll', check);
    };
  }, []);
  return {
    sticked,
    toolbar
  };
};